import { useEffect } from 'react';
import { escapeSingleQuotedString } from '@/public/template/library/EscapeUtils';

interface IProps {
  contentId?: string;
  topicsId?: number;
  mtestId: string;
  ssJoinIdParam?: {
    type: string;
    id: string;
  };
}
const PageView: React.FC<IProps> = props => {
  const handleBFCache = (event: PageTransitionEvent) => {
    if (event.persisted) {
      window.ualcmds = window.ualcmds || [];
      window.ual =
        window.ual ||
        function () {
          window.ualcmds.push(arguments);
        };
      window.ual('config', 'token', '5ae7ece4-3b93-4890-8f24-ce16ddd756ed');
      const ssJoinId = props.ssJoinIdParam?.id ? `${props.ssJoinIdParam.id}&is_bfche=1` : 'is_bfche=1';
      window.ual(
        'hit',
        'pageview',
        {
          service: 'news',
          opttype: 'pc',
          content_id: props.topicsId ?? props.contentId,
          id_type: getIdType(props.topicsId, props.contentId),
          ss_join_id: ssJoinId,
          ss_join_id_type: props.ssJoinIdParam?.type,
          mtestid: props.mtestId
        },
        { flush: true }
      );
    }
  };
  useEffect(() => {
    window.addEventListener('pageshow', handleBFCache);
    return () => window.removeEventListener('pageshow', handleBFCache);
  }, []);
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
          window.ualcmds = window.ualcmds || [];
          window.ual = window.ual || function() {
            ualcmds.push(arguments);
          };
          ual('config', 'token', '5ae7ece4-3b93-4890-8f24-ce16ddd756ed');
          function hitPageView () {
            ual('hit', 'pageview', {
              service: 'news',
              opttype: 'pc',
              ${
                props.topicsId !== undefined || props.contentId !== undefined
                  ? `
                    content_id: '${escapeSingleQuotedString(String(props.topicsId ?? props.contentId))}',
                    id_type: '${props.topicsId !== undefined ? 'news_topics' : 'shannon_article'}',
                    `
                  : ''
              }
              ${
                props.ssJoinIdParam
                  ? `
                    ss_join_id: '${escapeSingleQuotedString(props.ssJoinIdParam.id)}',
                    ss_join_id_type: '${escapeSingleQuotedString(props.ssJoinIdParam.type)}',
                    `
                  : ''
              }
              mtestid:'${escapeSingleQuotedString(props.mtestId)}'
              },
              { flush: true }
            );
          };
          if (document.prerendering) {
            document.addEventListener('prerenderingchange', hitPageView, {
              once: true
            });
          } else {
            hitPageView();
          }
        `
      }}
    />
  );
};

const getIdType = (topicsId?: number, contentId?: string): string | undefined => {
  if (topicsId) {
    return 'news_topics';
  }
  if (contentId) {
    return 'shannon_article';
  }
  return undefined;
};

export default PageView;
